import { Pipe, PipeTransform } from '@angular/core';
import moment from 'moment';

@Pipe({
    name: 'momentFormat',
    standalone: false
})
export class MomentFormatPipe implements PipeTransform {
    transform(value: Date | moment.MomentInput, format: string = 'LLLL'): string {
        return moment(value).format(format);
    }
}
